import palette from '../../palette';

export default {
  root: {
    fontSize: '14px',
    lineHeight: '21px',
    borderBottom: `1px solid ${palette.grayBg}`
  },
  head: {
    color: palette.white
  }
};
